//|---------------------------------------------------------------------|
//|                                                                     |
//|                       Abandon All Hope                              |
//|                                                                     |
//|                      Ye Who Debug Here                              |
//|                                                                     |
//|---------------------------------------------------------------------|
import ResultNode from "../ResultNode";

export default function ResultList(props) {
  const { answer, questionNumber } = props;
  return (
    <ResultNode
      data={answer}
      idx={questionNumber + 1}
      isCorrect={answer.correct}
    />
  );
}
